export function rafThrottle(callback) {
  let isScheduled = false;

  return (...args) => {
    if (isScheduled) return;
    isScheduled = true;
    requestAnimationFrame(() => {
      isScheduled = false;
      callback(...args);
    });
  };
}

export function debounce(callback, wait = 120) {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      callback(...args);
    }, wait);
  };
}

export function initSwipers(selector, createOptions) {
  const sliders = document.querySelectorAll(selector);
  if (!sliders.length || typeof Swiper === "undefined") return;

  sliders.forEach((slider) => {
    const options =
      typeof createOptions === "function" ? createOptions(slider) : createOptions;
    if (!options) return;
    new Swiper(slider, options);
  });
}
export function initSmoothScroll(linksSelector = 'a[href^="#"]') {
	const links = document.querySelectorAll(linksSelector);

	links.forEach(link => {
		link.addEventListener('click', function (event) {
			event.preventDefault();

			const targetId = this.getAttribute('href');

			if (targetId === '#') return;

			const targetSection = document.querySelector(targetId);

			if (targetSection) {
				targetSection.scrollIntoView({
					behavior: 'smooth',
					block: 'center'
				});
			}
		});
	});
}
